import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SystemResourceComponent} from './resource/resource.component';
import {SystemDictComponent} from './dict/dict.component';

const routes: Routes = [

  { path: 'resource', component: SystemResourceComponent },
  { path: 'dict', component: SystemDictComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SystemRoutingModule { }
